<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-close grow" @click="$store.commit('hideFindBook')">
            <i class="material-icons">close</i>
          </div>

          <template v-if="!canPick">
            <div class="modal-title">Reading Limit Reached</div>
            <div class="modal-limit-instructions">
              To ensure that all readers can find a book to review, we allow
              each user to review up to two books at a time.
              <br />Please complete or cancel one of your two active assignments
              before choosing a new book to review.
            </div>
          </template>
          <template v-else-if="isWeeklyLimitReached">
            <div class="modal-title">Weekly Reading Limit Reached</div>
            <div class="modal-limit-instructions">
              We currently allow members to review up to five books every seven
              days.
              <br />
              <br />Please check back tomorrow to see if you are able to review
              more books!
            </div>
          </template>
          <template v-else>
            <div class="modal-title">Available For Review</div>
            <div class="modal-instructions">
              Browse our current selection of books. New books are added often.
            </div>

            <div class="hang-arrow" @click="clickPrevious">
              <i class="material-icons hang-arrow-i">keyboard_arrow_left</i>
            </div>
            <div class="hang-arrow hang-arrow-right" @click="clickNext">
              <i class="material-icons hang-arrow-i">keyboard_arrow_right</i>
            </div>
            <v-container class="over-container">
              <v-layout row wrap class="books-container">
                <v-flex
                  sm12
                  md4
                  v-for="assignment in recommendations"
                  :key="assignment.id"
                  @click="selectAssignment(assignment)"
                >
                  <card
                    :assignment="assignment"
                    :selected="selectedAssignmentId === assignment.id"
                    :find="true"
                  ></card>
                </v-flex>
              </v-layout>
            </v-container>

            <div class="actions">
              <div class="action-refresh">&nbsp;</div>
              <div class="action-selection">
                <div
                  class="action"
                  :class="{ 'action-disabled': !selectedAssignmentId }"
                  @click="acceptAssignment()"
                >
                  {{ actionLabel }}
                </div>
                <div class="confirm-text hidden-sm-and-down">
                  <template v-if="selectedAssignmentId">
                    You'll earn
                    <span class="points-text"
                      >{{
                        selectedAssignment.reward_points | bigNumber
                      }}
                      snaps</span
                    >
                    for reviewing
                    <span class="book-title">{{
                      selectedAssignment.book.title
                    }}</span>
                    by {{ selectedAssignment.proposed_due_at | shortDate }}
                    <span style="color: #999">(midnight EST)</span>
                  </template>
                </div>
              </div>
              <div class="action-refresh">
                <!-- <div class="action-refresh-item" @click="clickPrevious" v-if="isRefreshed">Previous</div>
                <div class="action-refresh-item" @click="clickRefresh" v-else>Refresh</div>-->
              </div>
            </div>
            <div
              class="confirm-text hidden-md-and-up"
              style="padding: 16px 20px"
              v-if="selectedAssignmentId"
            >
              You'll earn
              <span class="points-text"
                >{{ selectedAssignment.reward_points | bigNumber }} snaps</span
              >
              for reviewing
              <span class="book-title">{{
                selectedAssignment.book.title
              }}</span>
              by {{ selectedAssignment.proposed_due_at | shortDate }}
              <span style="color: #999">(midnight EST)</span>
            </div>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Back from "../../modules/Back";
import Bus from "../../modules/Bus";
import Card from "../Assignment/Card";

export default {
  name: "FindBook",
  components: { Card },
  data: function () {
    return {
      dialog: false,
      recommendations: [],
      selectedAssignmentId: null,
      selectedAssignment: null,
      isRefreshed: false,
      page: 1,
    };
  },
  computed: {
    actionLabel() {
      return this.selectedAssignmentId ? "Pick Book" : "Select Option";
    },
    canPick() {
      if (this.$store.state.user.memberType === "press") {
        return true;
      }
      if (
        this.$store.state.user.id === 39 ||
        this.$store.state.user.id === 245 ||
        this.$store.state.user.id === 21
      ) {
        return true;
      }

      let activeCount = 0;
      for (const assignment of this.$store.state.assignments) {
        if (
          assignment.status === "Assigned" ||
          assignment.status === "Waiting"
        ) {
          activeCount++;
        }
      }

      return activeCount < 2;
    },
    isWeeklyLimitReached() {
      // console.log("type", this.$store.state.user.memberType);
      if (this.$store.state.user.memberType === "press") {
        return false;
      }
      if (
        this.$store.state.user.id === 39 ||
        this.$store.state.user.id === 245 ||
        this.$store.state.user.id === 21
      ) {
        return false;
      }

      let activeCount = 0;
      const now = new Date();
      const nowTime = new Date().getTime();

      for (const assignment of this.$store.state.assignments) {
        if (!assignment.started_at) {
          continue;
        }

        const assignmentDate = new Date(
          assignment.started_at.replace(/-/g, "/")
        );
        const assignmentTime = assignmentDate.getTime();

        const diff =
          nowTime - (assignmentTime - now.getTimezoneOffset() * 60 * 1000);

        if (diff < 604800 * 1000) {
          activeCount++;
        } else {
        }
      }

      return activeCount > 7;
    },
  },
  methods: {
    selectAssignment(assignment) {
      this.selectedAssignmentId = assignment.id;
      this.selectedAssignment = assignment;
      // console.log("selected assignment", this.selectedAssignmentId);
    },
    async clickPrevious() {
      this.page--;

      if (this.page < 1) {
        this.page = 4;
      }

      this.recommendations = await Back.recommend(this.page);
      //this.isRefreshed = false;
    },
    async clickNext() {
      this.page++;

      if (this.page > 4) {
        this.page = 1;
      }

      this.recommendations = await Back.recommend(this.page);
      //this.isRefreshed = false;
    },
    async clickRefresh() {
      console.log("refresh");
      this.recommendations = await Back.refreshRecommendations();
      this.isRefreshed = true;
      // console.log("recommendations", this.recommendations);
    },
    async acceptAssignment() {
      if (!this.selectedAssignment) {
        return;
      }

      try {
        const assignment = await Back.startAssignment(
          this.selectedAssignmentId
        );
        if (!assignment) {
          // TODO: Display error.
        } else {
          this.$router.push("/assignments/" + this.selectedAssignmentId);
          this.$toasted.show(
            "Great! You're assigned to read " +
              this.selectedAssignment.book.title +
              " now.",
            {
              icon: "check_circle",
              position: "bottom-center",
              duration: 3000,
            }
          );
          this.$store.commit("hideFindBook");
          // console.log("emit UserChanged");
          Bus.$emit("UserChanged", this.selectedAssignment.book);
        }
      } catch (err) {
        // TODO: Display error.
      }
    },
  },
  async created() {
    this.recommendations = await Back.recommend();
    // console.log("recommendations", this.recommendations);
  },
};
</script>

<style lang="scss" scoped>
.modal-title {
  border-bottom: 1px solid #e3e3e3;
  padding: 0.5em;
  padding-left: 60px;
  font-size: 21pt;
  font-weight: 500;
  color: #111;
  text-align: center;
}
.modal-instructions {
  padding-top: 16px;
  font-size: 14pt;
  color: #111;
  text-align: center;
}
.modal-limit-instructions {
  padding: 60px 120px;
  font-size: 13.5pt;
  color: #111;
  text-align: center;
}
.modal-close {
  font-size: 15pt;
  margin-top: 10px;
  margin-right: 16px;
  padding: 7px 0 0 6.5px;
  width: 36px;
  height: 36px;
  border-radius: 100px;
  float: right;
  position: relative;
  transition: all 0.2s ease-in-out;
}
.modal-close:hover {
  background: #eee;
  transform: scale(1.1);
  cursor: pointer;
}

.hang-arrow {
  opacity: 0.5;
  transition: all 0.2s ease-in-out;
}
.hang-arrow:hover {
  opacity: 1;
  cursor: pointer;
}

.find-book {
  background: #fff;
  box-shadow: 0 0 1.5rem rgba(0, 0, 0, 0.14);
  font-family: $font-family;
}

.over-container {
  padding-top: 20px !important;
  padding-bottom: 12px !important;
}
.books-container {
  min-height: 264px;
}

.actions {
  display: flex;
  justify-content: center;
  padding: 4px;
}
.action-selection {
  flex-grow: 0;
  text-align: center;
}
.action-refresh {
  flex-grow: 0;
  flex-basis: 260px;
  margin-left: auto;
  padding-right: 48px;
  text-align: center;
}
.action-refresh-item {
  float: right;
  width: 120px;
  text-align: center;
  border: 0px solid #f3f3f3;
  border-radius: 8px;
  margin: 0 8px;
  padding: 0.4em 0.75em;
  font-size: 12pt;
  color: #777;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.action-refresh-item:hover {
  cursor: pointer;
  color: #999;
}
.action {
  background: #ede7f6;
  color: #9575cd;
}

@media (max-width: 1024px) {
  .action-refresh {
    flex-basis: 140px;
    padding-right: 0;
  }
}

.confirm-text {
  height: 60px;
  padding: 0.75em 0 0 0;
  font-size: 11.5pt;
  color: #333;
  text-align: center;
}

.points-text {
  color: darken(#ffa000, 6%);
  font-weight: 700;
}
.book-title {
  color: $color-blue;
  font-weight: 700;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  z-index: 100000;
}

.modal-container {
  z-index: 999999;
  max-width: 1240px;
  min-height: 490px;
  margin: 0px auto;
  padding: 8px 0px 12px 0px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 2.5rem rgba(0, 0, 0, 0.19);
  transition: all 0.3s ease;
  font-family: "Source Sans Pro";
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

@media (max-width: 1024px) {
  .modal-mask {
    position: absolute !important;
  }
  .modal-container {
    height: auto;
    width: 100%;
    max-width: 100%;
    padding: 20px 0;
  }

  .modal-title {
    text-align: left;
    font-size: 19pt;
    padding-top: 1px;
    padding-left: 18px;
    padding-right: 0;
  }

  .modal-close {
    float: right !important;
    position: initial !important;
    margin-right: 12px !important;
  }
}

.hang-arrow {
  float: left;
  width: 50px;
  padding: 120px 0 0 0;
  text-align: center;
}
.hang-arrow-right {
  float: right;
}
.hang-arrow-i {
  font-size: 48px;
  color: #111;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>


